import {
  AutocompleteResult,
  Contact,
  ContactGuest,
  Entity,
  EntityGuest,
} from '@admiin-com/ds-graphql';

export const getContactName = (contact: Contact | null | undefined) => {
  if (!contact) return '';
  return contact.name || `${contact.firstName} ${contact.lastName}`;
};
export const getName = (
  contact:
    | AutocompleteResult
    | Contact
    | Entity
    | ContactGuest
    | EntityGuest
    | null
    | undefined
) => {
  if (!contact) return '';
  if ('name' in contact && contact.name)
    return getContactName(contact as Contact);
  if ('label' in contact) return contact.label;
  if (
    'firstName' in contact &&
    'lastName' in contact &&
    contact.firstName &&
    contact.lastName
  ) {
    return `${contact.firstName} ${contact.lastName}`;
  } else return contact.name ?? '';
};
